import PropTypes from 'prop-types';
import React, {Component} from 'react';
import CollapseList from "~/ui/ReactML/CollapseList";
import {
    Alert,
    VStack,
    WithBaseStyles,
    renderHTML,
    getDefaultComponent,
    HighLightText,
    extractNativeProps,
    Dialog
} from '~/native-ui';
import { List } from "~/native-ui/List";


const StyledCollapseList = WithBaseStyles(CollapseList, {
    defaultProps: {
        space: "1",
        renderAsList: true,
        flex: "1",
        ml: 0,
    }
})

const Link = (props) => {
    const LinkComponent = getDefaultComponent('a');
    if (!LinkComponent) return null;
    return <LinkComponent {...props} color="inherit" />;
}

const Span = ({ "data-highlight": _dataHighlight, ...props}) => {
    const SpanComponent = getDefaultComponent("span");
    if (!SpanComponent) return null;

    return <SpanComponent {...props} />
}

const ListItem = (props) => {
    return <List.Item {...props} unstyled={false} />
}


export default class MessageList extends Component {
    static propTypes = {
        messages: PropTypes.array.isRequired,
        level: PropTypes.string,
        className: PropTypes.string,
        hideMessages: PropTypes.func,
    };

    ref = React.createRef();

    componentDidUpdate(prevProps) {
        if (!this.props.lastMessageCreatedAt) return;
        if (this.props.lastMessageCreatedAt === prevProps.lastMessageCreatedAt) return;

        this.scrollIntoView();
    }


    formatMessage = (mData, i) => {
        const linkComponent = mData.status !== "default" ? {a: Link } : {};

        let message = renderHTML(mData.message, {ul: StyledCollapseList, li: ListItem, span: Span, ...linkComponent });
        let highlightTextLevel = {
            danger: "error",
            validation_error: "error",
            success: "success",
            warning: "warning",
            info: "info",
        }

        return (
            <HighLightText aria-description="HIGHLIGHT" data-highlight={highlightTextLevel[mData.type]} key={i+""} _web={{style: {display: "block", width: "100%"}}} >
                <VStack color="inherit" flexDirection="column" py={0} alignItems="flex-start" width="100%" key={mData.message}>
                    {message}
                </VStack>
            </HighLightText>
        );
    };

    getGroupedMessages () {
        let { messages } = this.props;
        let groupedMessages = {
            error: [],
            warning: [],
            success: [],
            info: [],
            default: [],
        };

        return messages.reduce((messages, message) => {
            if (!messages[message.type]) {
                // ensure message goes into default group if it isn't supported
                message = {...message, type: "default"};
            }

            messages[message.type].push(this.formatMessage(message));
            return messages
        }, groupedMessages);
    }

    renderListOrItem(messages) {
        if (messages.length < 1) {
            return null;
        }

        if (messages.length <= 1) {
            return <>{messages}</>
        }

        messages = messages.map((message, i) => {
            return <List.Item alignItems="flex-start" key={i+""}>{message}</List.Item>
        })

        return (
            <StyledCollapseList isExpanded >
                {messages}
            </StyledCollapseList>
        );
    }

    renderMessageGroup(type, messages) {
        if (!messages) return null;

        return (
            <Alert variant="subtle" space="1" flexDirection="column" status={type} alignItems={"flex-start"} colorScheme={type} key={type}>
                    {messages}
                {/* {
                    this.props.hideMessages &&
                    <View position="absolute" top={ .5 } right={ .5 } ><IconButton type={'close'} onClick={this.props.hideMessages} /></View>
                } */}
            </Alert>
        );
    }

    scrollIntoView() {
        if (!this.ref.current) return;
        this.ref.current.scrollIntoView?.({ behavior: "smooth", block: "end",  });
    }

    render() {
        const [stackProps, { messages, }] = extractNativeProps(this.props);

        if(!messages.length) { return null; }


        let renderedMessages = Object.entries(this.getGroupedMessages()).map(([group, messages]) => {
            return this.renderMessageGroup(group, this.renderListOrItem(messages));
        });
/*

        return (
            <Dialog title={"yolo"} active={true} actions={[
                { label: 'Peace' },
                { colorScheme: 'primary', label: 'Close the shit', onClick: () => alert('YEAH') },
            ]}>
                <div>wadawddaw</div>
            </Dialog>
        );

*/

        return (
            <VStack ref={this.ref} space="2" mb={4} {...stackProps} flexGrow="0" flexDirection="column">
                {renderedMessages}
            </VStack>
        );
    }
}
